module.exports = __webpack_public_path__ + "img/禁止访问.c461110b.png";